/*
  HIRO dispatch and delivery message (PDP, under Add to Cart).
  Rules (Fadi, 9 Oct 2026): 14:00 UK cut-off Mon to Fri for standard and express.
  Standard arrives 2 working days after dispatch, express 1. Bank holidays and closed
  days are not working days. Christmas last-order dates shown from 1 Nov.
  Config lives in snippets/dispatch-message.liquid. All maths is on UK wall-clock time.
  Test a moment in time with ?dispatch_now=2026-12-18T15:00 (UK time).
  Live countdown (Fadi, 11 Oct 2026): "Order in the next 2h 46m for delivery on Tuesday",
  counting to whichever cut-off decides that date, ticking each second, with a pulsing dot.
*/
(function (root) {
  'use strict';

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Calendar dates are held as UTC midnight Dates; only y/m/d/weekday matter.
  function mkDate(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function iso(dt) { return dt.toISOString().slice(0, 10); }
  function addDays(dt, n) { return new Date(dt.getTime() + n * 86400000); }
  function fmt(dt) { return DAYS[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + MONTHS[dt.getUTCMonth()]; }

  // UK wall-clock parts for an instant.
  var londonFmt;
  function londonParts(instant) {
    londonFmt = londonFmt || new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    var p = {};
    londonFmt.formatToParts(instant).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, min: +p.minute, s: +p.second };
  }

  // "2026-12-18T15:00" read as UK wall-clock time.
  function parseLocal(s) {
    var m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?$/);
    if (!m) return null;
    return { y: +m[1], m: +m[2], d: +m[3], h: +(m[4] || 0), min: +(m[5] || 0) };
  }

  function key(p) { return p.y * 1e8 + p.m * 1e6 + p.d * 1e4 + p.h * 100 + p.min; }

  // Hours and minutes; minutes and seconds in the last hour.
  function countdown(secs) {
    var h = Math.floor(secs / 3600), m = Math.floor(secs % 3600 / 60), s = secs % 60;
    if (h > 0) return h + 'h ' + (m < 10 ? '0' : '') + m + 'm';
    return m > 0 ? m + 'm ' + (s < 10 ? '0' : '') + s + 's' : s + 's';
  }

  function compute(now, cfg, opts) {
    opts = opts || {};
    var off = {};
    (cfg.bank_holidays || []).concat(cfg.closed_days || []).forEach(function (d) { off[d] = true; });
    function working(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && !off[iso(dt)]; }
    function nextWorking(dt) { do { dt = addDays(dt, 1); } while (!working(dt)); return dt; }
    function addWorking(dt, n) { for (var i = 0; i < n; i++) dt = nextWorking(dt); return dt; }

    var today = mkDate(now.y, now.m, now.d);
    var nowMins = now.h * 60 + now.min;
    var cutMins = cfg.cutoff_hour * 60;
    var sameDay = working(today) && nowMins < cutMins;
    var dispatch = sameDay ? today : nextWorking(today);
    var standard = addWorking(dispatch, cfg.standard_days);
    var express = addWorking(dispatch, cfg.express_days);
    // Seconds until the cut-off on the despatch day, which is what decides the delivery date.
    var gap = Math.round((dispatch - today) / 86400000);
    var secsLeft = (gap * 1440 + cutMins - nowMins) * 60 - (now.s || 0);
    var minsLeft = Math.ceil(secsLeft / 60);

    // One line: "Order in the next 2h 46m for delivery on Tuesday".
    // The day is a button: hover (desktop) or tap (mobile) shows standard vs express.
    var daysToStd = Math.round((standard - today) / 86400000);
    var daysToExp = Math.round((express - today) / 86400000);
    var expLabel = daysToExp === 1 ? 'tomorrow, ' + fmt(express) : fmt(express);
    var stdLabel = daysToStd <= 6 ? DAYS_LONG[standard.getUTCDay()] : fmt(standard);
    var arrives = ' for delivery ' + (daysToStd === 1 ? '' : 'on ') + '<span class="dm-when"><button type="button" class="dm-day" aria-expanded="false" aria-controls="dm-pop">' + (daysToStd === 1 ? 'tomorrow' : stdLabel) + '</button>' +
      '<span class="dm-pop" id="dm-pop" role="tooltip">' +
      (opts.subscription
        ? 'Subscriptions ship <strong>free</strong> on standard delivery (2 working days). Arrives <strong>' + fmt(standard) + '</strong>.'
        : '<strong>Standard</strong>, 2 working days: ' + (cfg.standard_price_text || '£2.99, free over £30') + '. Arrives <strong>' + fmt(standard) + '</strong>.<br>' +
          '<strong>Express</strong>, next working day: ' + (cfg.express_price_text || '£4.50, free over £60') + '. Arrives <strong>' + expLabel + '</strong>. Choose it at checkout.') +
      '</span></span>';
    // Count down when the cut-off is within 24 hours (weekday evenings and Sunday afternoons
    // included); further off, e.g. Friday night or Saturday, a 40-hour timer reads oddly.
    var timer = secsLeft <= 86400 ? countdown(secsLeft) : null;
    var line = timer
      ? 'Order in the next <strong class="dm-cd" data-dm-cd></strong>' + arrives
      : 'Order now' + arrives;

    // Christmas: one short line until the express last-order time, then nothing.
    var xmas = null;
    var x = cfg.christmas;
    if (x && x.enabled) {
      var k = key(now);
      var from = parseLocal(x.banner_from);
      var stdLast = parseLocal(x.standard_last_order), expLast = parseLocal(x.express_last_order);
      if (k >= key(from) && k < key(stdLast)) {
        xmas = 'Christmas: order by ' + fmt(mkDate(stdLast.y, stdLast.m, stdLast.d));
      } else if (k >= key(from) && k < key(expLast)) {
        xmas = 'Christmas: order by ' + fmt(mkDate(expLast.y, expLast.m, expLast.d)) + ' with Express';
      }
    }

    return {
      dispatch: iso(dispatch), standard: iso(standard), express: iso(express),
      sameDay: sameDay, minsLeft: minsLeft, secsLeft: secsLeft, timer: timer, line: line, xmas: xmas
    };
  }

  var api = { compute: compute, londonParts: londonParts, parseLocal: parseLocal, fmt: fmt };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.HiroDispatch = api;

  function bind(el) {
    var cfg;
    try { cfg = JSON.parse(el.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    if (!cfg.enabled) return;
    var forced = null;
    try { forced = parseLocal(new URLSearchParams(location.search).get('dispatch_now')); } catch (e) {}
    var form = el.closest('form') || document;
    var btn = form.querySelector('.ProductForm__AddToCart');
    function render() {
      var sp = form.querySelector('[name="selling_plan"]');
      var r = compute(forced || londonParts(new Date()), cfg, { subscription: !!(sp && sp.value && !sp.disabled) });
      var lineEl = el.querySelector('[data-dm-line]');
      if (lineEl.getAttribute('data-html') !== r.line) {
        lineEl.innerHTML = r.line;
        lineEl.setAttribute('data-html', r.line);
        setOpen(open);
      }
      // The timer ticks in its own element so the day button and popover are not rebuilt each second.
      var cd = lineEl.querySelector('[data-dm-cd]');
      if (cd) cd.textContent = r.timer;
      var xm = el.querySelector('[data-dm-xmas]');
      xm.textContent = r.xmas || '';
      xm.hidden = !r.xmas;
      el.hidden = !!(btn && btn.disabled);
    }
    var open = false;
    function setOpen(v) {
      open = v;
      el.classList.toggle('is-open', v);
      var b = el.querySelector('.dm-day');
      if (b) b.setAttribute('aria-expanded', v ? 'true' : 'false');
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest('.dm-day')) { e.preventDefault(); setOpen(!open); }
    });
    document.addEventListener('click', function (e) { if (open && !el.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) setOpen(false); });
    render();
    if (!forced) setInterval(render, 1000);
    form.addEventListener('change', function () { setTimeout(render, 60); });
    form.addEventListener('click', function () { setTimeout(render, 80); });
  }

  function init() { document.querySelectorAll('[data-dispatch-message]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(this);
